<template>
    <div>
        <div>
            <div class="marginBottom20">
                <div class="marginBottom20" v-if="selectUserList.length != 0">
                    <div class="nickname" v-for="(v, i) in selectUserList" :key="i">
                        {{v.nickname}}
                    </div>
                </div>
                <el-button @click="handleChooseUsers">选择用户</el-button>
            </div>
            <div class="marginBottom20">用户身份</div>
            <div class="marginBottom20">
                <el-radio-group v-model="addForm.identityType" size="mini" @change="() => {
                    addForm.gatewayIds = [];
                }
                    ">
                    <el-radio-button label="2" border>管理员</el-radio-button>
                    <el-radio-button label="3" border style="margin-left: 15px">成员</el-radio-button>
                </el-radio-group>
            </div>
            <div class="marginBottom20">用户所属网关（多选）</div>
            <div class="marginBottom20">
                <el-checkbox-group v-if="addForm.identityType == 3" v-model="addForm.gatewayIds">
                    <el-checkbox-button v-for="item in gatewayList" :label="item.id" border style="margin-right: 15px"
                        :key="item.id">
                        {{ item.name }}</el-checkbox-button>
                </el-checkbox-group>
                <el-checkbox-group v-else v-model="addForm.gatewayIds">
                    <el-checkbox-button label="0" border style="margin-right: 15px" key="0">
                        全部网关</el-checkbox-button>
                </el-checkbox-group>
            </div>
            <div style="text-align: center">
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button type="primary" @click="submitAddMember(addForm)" :loading="showLoadingAddForm">确定</el-button>
            </div>
        </div>

        <!--选择用户弹窗-->
        <el-dialog v-if="userDialogVisible" :title="`${'请选择成员'}`" :visible.sync="userDialogVisible" width="50%"
            :before-close="handleUserDialogClose" append-to-body>
            <!-- 用户列表 -->
            <div>
                <avue-crud ref="crud" :data="userData" :option="option" :page.sync="page" @on-load="onLoad"
                    @selection-change="selectionChange" :reserveSelection="temporaryUserList">
                    <!-- 搜索栏 -->
                    <template #header>
                        <div>
                            <div class="flex align-items marginBottom20">
                                <div class="flex align-items marginRight10">
                                    <div class="width200">
                                        <el-input v-model="searchData.nickname" placeholder="请输入用户昵称或手机号" clearable
                                            maxlength="50"></el-input>
                                    </div>
                                </div>
                                <el-button size="medium" type="primary" @click="handleSearch"
                                    class="marginLeft10">搜索</el-button>
                            </div>
                        </div>
                    </template>
                </avue-crud>
            </div>
            <div style="text-align: center; margin-top: 10px;">
                <el-button @click="cancelClick">取消</el-button>
                <el-button type="primary" @click="submitMember(selectUserList)"
                    :loading="showLoadingChoice">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import {
    userAdd,
    selectList
} from "@/api/user/group"

export default {
    name: "GroupAdduserDialog",
    props: {
        gatewayList: {
            type: [Array],
            default: [],
        },
        groupId: {
            type: [Number, String],
            default: "",
        },
        filteredList: {
            type: [Array],
            default: [],
        },
    },
    data() {
        return {
            //向添加分组接口传参
            addForm: {
                userIds: [],
                identityType: "2",
                gatewayIds: [],
            },
            //所有用户列表
            userData: [],
            //列表设置
            option: {
                title: "",
                titleSize: "h3",
                card: false,
                border: true,
                header: false,
                stripe: false, // 显示斑马纹
                showHeader: true, // 显示表头
                index: false, // 显示索引
                indexLabel: "序号", // 索引文字
                size: "small",
                page: true, // 显示分页
                align: "center",
                menu: false,
                menuAlign: "center",
                menuType: "text",
                editBtn: false,
                delBtn: false,
                selection: true,
                selectable: (row, index) => {
                    return !this.filteredList.some(item => item.userId == row.userId)
                },
                reserveSelection: true,
                selectionFixed: true,
                tip: false,
                column: [
                    {
                        label: "用户ID",
                        prop: "userId",
                    },
                    {
                        label: "昵称",
                        prop: "nickname",
                    },
                    {
                        label: "手机号",
                        prop: "phone",
                        width: 150,
                    }
                ],
            },
            //页数信息
            page: {
                total: 0,
                currentPage: 1,
            },
            //用户搜索信息
            searchData: {
                nickname: "",
            },
            
            selectUserList: [],//表格确认勾选中的用户
            temporaryUserList: [],//缓存当前选择的用户
            showLoadingAddForm: false,//添加成员弹窗缓冲
            userDialogVisible: false,//选择成员弹窗可见标志
            dialogChange: false,//选择成员弹窗是否从无到有
            showLoadingChoice: false,//选择成员弹窗缓冲
        }
    },
    watch: {
        userDialogVisible(nVal) {
            //当已经选择过用户又重新打开选择页面时
            if (nVal && this.selectUserList.length) {
                this.$nextTick(() => {
                    //同步用户的选择
                    this.dialogChange = true
                });
            } else {
                this.dialogChange = false
            }
        }
    },
    methods: {
        //打开选择分组弹窗
        handleChooseUsers() {
            this.userDialogVisible = true
        },
        //关闭当前弹窗
        handleDialogClose() {
            this.$emit("close");
        },
        //关闭用户列表弹窗
        handleUserDialogClose() {
            this.userDialogVisible = false
        },
        //表格左侧选择的数据的
        selectionChange(list) {
            this.temporaryUserList = list;
        },
        //用户选择列表点击取消
        cancelClick() {
            this.handleUserDialogClose();
        },
        //用户选择列表点击确认
        submitMember(form) {
            this.selectUserList = this.temporaryUserList;
            this.handleUserDialogClose();
        },
        //用户选择列表搜索
        handleSearch() {
            this.page.currentPage = 1;
            this.onLoad();
        },
        //同步列表中已选择的用户
        toggleSelection(val) {
            this.$refs.crud.toggleSelection(val);
        },
        //用户选择列表加载事件
        onLoad() {
            this.showLoadingChoice = true;
            const searchData = {
                nickname: this.searchData.nickname,
            };
            selectList({
                page: this.page.currentPage,
                size: this.page.pageSize,
                ...searchData,
            }).then((res) => {
                if (res.code === 200) {
                    this.userData = res.data.records;
                    this.page.total = res.data.total;
                    if (this.selectUserList.length && this.dialogChange) {
                        this.toggleSelection(this.selectUserList);
                        this.dialogChange = false;
                    }
                }
                this.showLoadingChoice = false;
            });
        },
        //提交分组添加的用户
        submitAddMember(form) {
            if (!(this.selectUserList && this.selectUserList.length)) {
                this.$message.error("请选择成员");
                return;
            }

            const params = {
                groupId: this.groupId,
                gatewayIds: form.identityType == 2 ? ""
                    : form.gatewayIds.join(","),
                identityType: form.identityType,
                userIds: this.selectUserList.map((obj) => obj.id),
            }

            userAdd(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success("操作成功");
                    this.$emit("close");
                }
            })

        }
    }
}
</script>

<style lang="scss" scoped>
.nickname{
    display: inline;
    color: white;
    background-color:var(--primary-color);
    border-radius: 4px;
    padding: 4px;
    margin-right: 10px;
    width: 100%;
}
</style>